import { styled } from '@mui/material/styles';
import { Box, alpha } from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
  background: theme.palette.background.primary,
  zIndex: `calc(${theme.zIndex.appBar} - 1)`,
  '& .MuiTab-root': {
    padding: theme.spacing(1.5, 1.75),
    fontSize: theme.spacing(2),
    textTransform: 'capitalize',
    color: theme.palette.text.secondary,
    minWidth: 'unset',
    minHeight: 'unset',
    fontWeight: 400,
    '&.Mui-selected': {
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.common.white,
    height: theme.typography.pxToRem(1),
  },
  '& .MuiTab-iconWrapper': {
    position: 'relative',
    top: theme.spacing(-0.25),
  },
}));
export default StyledBox;
